<p>
  {{ 'sharedModule.bkgVehicleDialogNotFoundForm.text' | translate }}
</p>

<form
  [formGroup]="missingCarModelForm"
  autocomplete="off"
  class="modal__section form-compact"
>
  <div class="form-group">
    <input
      formControlName="make"
      type="text"
      placeholder="{{
        'sharedModule.bkgVehicleDialogNotFoundForm.make' | translate
      }}"
      name="make"
      autocomplete="off"
    />

    <input
      formControlName="model"
      type="text"
      placeholder="{{
        'sharedModule.bkgVehicleDialogNotFoundForm.model' | translate
      }}"
      name="model"
      autocomplete="off"
    />

    <input
      *ngIf="emailControl"
      formControlName="email"
      type="text"
      placeholder="{{
        'sharedModule.bkgVehicleDialogNotFoundForm.email' | translate
      }}"
      name="email"
      autocomplete="off"
    />
  </div>

  <button
    class="btn-primary btn-large is-block"
    [disabled]="missingCarModelForm.invalid"
    (click)="sendMissingCarModel()"
  >
    {{ 'sharedModule.bkgVehicleDialogNotFoundForm.send' | translate }}
  </button>
</form>
